import { z } from "zod"

import {
  fieldProjectionV10Schema,
  fieldVisitProjectionV10Schema,
} from "./field-projection-v10.js"
import { fieldVisitExecutionPlanProjectionV2Schema } from "./field-projection-v7.js"

export const fieldVisitExecutionPlanProjectionV3Schema =
  fieldVisitExecutionPlanProjectionV2Schema.safeExtend({
    requiresPerformedScope: z.boolean(),
    requiresCompletionEvidence: z.boolean(),
    requiresCustomerAcknowledgment: z.boolean(),
  }).strict()

export const fieldVisitProjectionV11Schema = z.object({
  ...fieldVisitProjectionV10Schema.shape,
  executionPlan: fieldVisitExecutionPlanProjectionV3Schema,
}).strict().superRefine((visit, context) => {
  const {
    requiresPerformedScope: _requiresPerformedScope,
    requiresCompletionEvidence: _requiresCompletionEvidence,
    requiresCustomerAcknowledgment: _requiresCustomerAcknowledgment,
    ...legacyPlan
  } = visit.executionPlan
  const parsed = fieldVisitProjectionV10Schema.safeParse({
    ...visit,
    executionPlan: legacyPlan,
  })
  if (!parsed.success) {
    for (const issue of parsed.error.issues) {
      context.addIssue({ code: "custom", message: issue.message, path: issue.path })
    }
  }
})

export const fieldProjectionV11Schema = z.object({
  ...fieldProjectionV10Schema.shape,
  responseVersion: z.literal(11),
  visits: z.array(fieldVisitProjectionV11Schema).max(100),
}).strict().superRefine((projection, context) => {
  const candidate = {
    ...projection,
    responseVersion: 10 as const,
    visits: projection.visits.map((visit) => {
      const {
        requiresPerformedScope: _requiresPerformedScope,
        requiresCompletionEvidence: _requiresCompletionEvidence,
        requiresCustomerAcknowledgment: _requiresCustomerAcknowledgment,
        ...legacyPlan
      } = visit.executionPlan
      return { ...visit, executionPlan: legacyPlan }
    }),
  }
  const parsed = fieldProjectionV10Schema.safeParse(candidate)
  if (!parsed.success) {
    for (const issue of parsed.error.issues) {
      context.addIssue({ code: "custom", message: issue.message, path: issue.path })
    }
  }
})

export type FieldProjectionV11 = z.infer<typeof fieldProjectionV11Schema>
export type FieldVisitProjectionV11 = z.infer<typeof fieldVisitProjectionV11Schema>
